import { useState, useRef, useEffect } from 'react';

function useQuery(fetchFunction, options) {
    const { debounceTime = 300, minQueryLength = 1 } = options || {};
    const [query, setQuery] = useState('');
    const [results, setResults] = useState(undefined);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(undefined);
    const controllerRef = useRef(undefined);
    useEffect(() => {
        if (!query || query.length < minQueryLength) {
            setResults(undefined);
            setLoading(false);
            setError(undefined);
            return;
        }
        const handler = setTimeout(() => {
            controllerRef.current?.abort();
            const controller = new AbortController();
            controllerRef.current = controller;
            setLoading(true);
            setError(undefined);
            fetchFunction(query, controller.signal)
                .then((data) => !controller.signal.aborted && setResults(data))
                .catch((err) => {
                if (err.name !== 'AbortError')
                    setError(err);
            })
                .finally(() => {
                if (!controller.signal.aborted)
                    setLoading(false);
            });
        }, debounceTime);
        return () => clearTimeout(handler);
    }, [query, fetchFunction, debounceTime, minQueryLength]);
    useEffect(() => () => controllerRef.current?.abort(), []);
    return { query, setQuery, results, loading, error };
}

export { useQuery };
